import {reactive, computed, inject as InjectType} from "vue";
import timeoutPromise from "@/utilities/timeoutPromise";
import {webDeskPost} from "@/services/webdesk/webDeskFetch";

type NfKioskCCRequestResponse = {
    amount: number,
    errorMessage: string,
    paymentType: string,
    success: boolean,
    transactionId: number
}

export const WebDeskKioskStore = reactive({
    isInKiosk: computed(() => window.hasOwnProperty('NfHotelKiosk')),
    async config() {
        return await timeoutPromise(
            // @ts-ignore
            window.NfHotelKiosk.send('NfKioskConfig'),
            'Nie udało się pobrać konfiguracji kiosku'
        );
    },
    async ccRequest(amount: number, title: string) {
        // @ts-ignore
        const response: NfKioskCCRequestResponse = await window.NfHotelKiosk.send('NfKioskRequestCC', [amount, title]);
        if (!response.success)
            throw new Error(response.errorMessage || 'Nie udało się wydać kart');
        const {printerSocketToken: hardwareToken} = await WebDeskKioskStore.config();
        await webDeskPost('payment/cc', {
            amount: response.amount,
            transactionId: response.transactionId,
            hardwareToken,
        });
    },
});
